export default function facebookPixelPlugin(userConfig = {}) {
  return {
    name: 'facebook-pixel-plugin',

    config: {
      id: userConfig.id,
      dataProcessingOptions: userConfig.dataProcessingOptions,
    },

    initialize: ({ config }) => {
      const { id, dataProcessingOptions } = config;

      // TODO: figure out if still necessary after removing heap
      // disabling ember-metrics is not enough, heap still tracks just by virtue of being loaded
      const metaTag = document.querySelector('meta[name="disable-metrics"]');

      if (metaTag) {
        return;
      }

      /* eslint-disable */
      // prettier-ignore
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */

      if (dataProcessingOptions) {
        const { method, country, state } = dataProcessingOptions;
        window.fbq('dataProcessingOptions', method, country, state);
      }

      window.fbq('init', id);
    },

    page: ({ payload }) => {
      window.fbq('track', 'PageView', payload);
    },

    track: ({ payload }) => {
      const { event, properties } = payload;

      if (!event) {
        return;
      }

      window.fbq('track', event, properties);
    },

    /* eslint-disable-next-line no-unused-vars */
    identify: ({ payload }) => {
      // not supported
    },

    loaded: () => {
      return !!window.fbq;
    },
  };
}
